import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from 'ui-components/components/button';
import Global from '../../store/global-selectors';
import { twelveHourUserSetting } from '../../constants/timezone-format';
import style from './style.module.less';
import messages from './messages';
import { FormattedMessage } from 'react-intl';
import { displayNewActivityEntry } from './display-activity-entry-component';
import useActivityData from './use-activity-data';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { EMPTY } from './constants';

const calculateUserDateTimeFormat = (dateFormat, timeFormat) => {
  const userTimeFormat = timeFormat === twelveHourUserSetting ? 'h:mm a' : 'H:mm';
  return `${dateFormat} ${userTimeFormat}`;
};

const NewFulfillmentPlanActivityComponent = ({ fpid }) => {
  const sellerUsers = useSelector(Global.selectSellerUsers);
  const sellerTimeZone = useSelector(Global.selectSellerTimeZoneIANA);
  const userTimeFormat = useSelector(Global.selectUserUserTimeFormat);
  const userDateFormat = useSelector(Global.selectUserUserDateFormat);
  const userDateTimeFormat = calculateUserDateTimeFormat(userDateFormat, userTimeFormat);

  const { activityEntries, pageToken, loadData, isLoading } = useActivityData(fpid);

  useEffect(() => {
    if (!activityEntries?.length && isLoading) {
      loadData();
    }
  }, [activityEntries, isLoading, loadData]);

  return (
    <>
      {isLoading ? (
        <LoadingIndicator className={style['loading-icon']} />
      ) : (
        <div className={style['fulfillment-plan-activity-list']}>
          {activityEntries?.length
            ? activityEntries?.map((activityEntry, index) =>
                displayNewActivityEntry(activityEntry, index, sellerTimeZone, userDateTimeFormat, sellerUsers),
              )
            : null}
          {pageToken !== EMPTY && (
            <Button className={style['button-load-all']} onClick={() => loadData()} theme='link'>
              <FormattedMessage {...messages.loadMore} />
            </Button>
          )}
        </div>
      )}
    </>
  );
};

NewFulfillmentPlanActivityComponent.propTypes = {
  fpid: PropTypes.string.isRequired,
};

export default NewFulfillmentPlanActivityComponent;
